import { NgClass, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { ConfirmDialogType, ConfirmService } from '../../../core/services/confirm/confirm.service';
import {disableScroll, enableScroll} from '../../utils/scroll-disable.utils';

@Component({
  selector: 'app-confirm',
  standalone: true,
  imports: [NgClass, NgIf],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.css',
})
export class ConfirmComponent implements OnInit, OnDestroy {
  private readonly confirmService = inject(ConfirmService);
  private dialogSub?: Subscription;

  protected dialogVisible = false;
  protected dialogTitle = 'Подтверждение';
  protected dialogMessage = 'Вы уверены?';
  protected type: ConfirmDialogType = 'delete';

  ngOnInit(): void {
    this.dialogSub = this.confirmService.getDialogState().subscribe((state) => {
      this.dialogVisible = state.visible;
      this.dialogTitle = state.title;
      this.dialogMessage = state.message;
      this.type = state.type;

      if (state.visible) {
        disableScroll();
      } else {
        enableScroll();
      }
    });
  }

  ngOnDestroy(): void {
    this.dialogSub?.unsubscribe();
    enableScroll();
  }

  protected onCancel(): void {
    this.confirmService.cancel();
  }

  protected onConfirm(): void {
    this.confirmService.confirm();
  }

  protected getButtonClass(): string {
    return this.type === 'confirm'
      ? 'confirm-button-success'
      : 'confirm-button-error';
  }
}
